import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    locales: [],
    dimensions: [],
    mimeTypes: [],
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.BANNERS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.BANNERS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.BANNERS_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.BANNERS_LOCALES_SUCCESS:
            return {
                ...state,
                locales: action.items
            };

        case AppConstants.BANNERS_DIMENSIONS_SUCCESS:
            return {
                ...state,
                dimensions: action.items
            };

        case AppConstants.BANNERS_MIME_TYPES_SUCCESS:
            return {
                ...state,
                mimeTypes: action.items
            };

        default:
            return state;
    }
};
